import React, { useState } from 'react';
import { Button, Form, required, SaveButton, TextInput, useNotify } from 'react-admin';
import IconContentAdd from '@mui/icons-material/Add';
import IconCancel from '@mui/icons-material/Cancel';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { dataProvider } from '../../firebase';

interface ICreateSimpleItemDialogButtonProps {
  onChange: () => void;
  resource: string;
  fieldNames: string[] | string;
}
// https://codesandbox.io/s/react-admin-v3-advanced-recipes-quick-createpreview-voyci?file=/src/comments/PostQuickCreateButton.js:0-3799
function CreateSimpleItemDialogButton(props: ICreateSimpleItemDialogButtonProps) {
  const [showDialog, setShowDialog] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const notify = useNotify();
  const fieldNames: string[] = [props.fieldNames].flat();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async (values: any) => {
    setIsDisabled(true);
    const data: any = {};
    fieldNames.forEach(fName => {
      data[fName] = values[`___${fName}`];
    });

    try {
      await dataProvider.create(props.resource, { data });
      setShowDialog(false);
      props.onChange();
    } catch (error) {
      notify(JSON.stringify(error), { type: 'error' });
    }
    setIsDisabled(false);
  };

  return (
    <>
      <Button onClick={handleClick} label="ra.action.create">
        <IconContentAdd />
      </Button>
      <Dialog fullWidth open={showDialog} onClose={handleCloseClick}>
        <DialogTitle>Create {props.resource}</DialogTitle>

        <Form resource={props.resource} onSubmit={handleSubmit}>
          <DialogContent>
            {fieldNames.map(fName => (
              <TextInput source={`___${fName}`} validate={required()} fullWidth key={fName} />
            ))}
          </DialogContent>
          <DialogActions>
            <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={isDisabled}>
              <IconCancel />
            </Button>
            <SaveButton disabled={isDisabled} />
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
}

export default CreateSimpleItemDialogButton;
